module.exports = __webpack_public_path__ + "img/new3.9677fc63.jpg";